export default __webpack_public_path__ + "static/media/automatic.ab442903.svg";